import { render, staticRenderFns } from "./UpgradeCard.vue?vue&type=template&id=71ec8261"
import script from "./UpgradeCard.vue?vue&type=script&lang=js"
export * from "./UpgradeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports